// eslint-disable-next-line import/prefer-default-export
export const STATE_NAME = 'ingredientEntries';
